<script setup lang="ts">

</script>

<template>
  <div class="grid grid-cols-6 gap-4">
    <Card class="col-span-3">
      <template #header>
        <div class="flex items-center justify-between px-4 py-2">
          <Skeleton width="10rem" />
          <Skeleton width="2rem" />
        </div>
        <Divider />
      </template>
      <template #content>
        <div class="flex items-center justify-center">
          <Skeleton shape="circle" size="30rem"></Skeleton>
        </div>
      </template>
    </Card>
    <Card class="col-span-2">
      <template #header>
        <div class="flex items-center justify-between px-4 py-2">
          <Skeleton width="10rem" />
          <Skeleton width="2rem" />
        </div>
        <Divider />
      </template>
      <template #content>
        <div class="flex items-center justify-center">
          <Skeleton size="28rem" />
        </div>
      </template>
    </Card>

    <div class="col-span-1">
      <Card class="mb-4">
        <template #header>
          <div class="flex items-center justify-between px-4 py-2">
            <Skeleton width="3rem" />
            <Skeleton width="1rem" />
          </div>
          <Divider />
        </template>
        <template #content>
          <Skeleton width="100%" class="mb-4" />
          <Skeleton width="100%" class="mb-4" />
          <Skeleton width="100%" class="mb-4" />
        </template>
      </Card>
      <Card>
        <template #header>
          <div class="flex items-center justify-between px-4 py-2">
            <Skeleton width="3rem" />
            <Skeleton width="1rem" />
          </div>
          <Divider />
        </template>
        <template #content>
          <Skeleton width="100%" class="mb-4" />
          <Skeleton width="100%" class="mb-4" />
          <Skeleton width="100%" class="mb-4" />
        </template>
      </Card>
    </div>
  </div>
</template>